module.exports = __webpack_public_path__ + "assets/6d9993081e53e9ceaee1fc09d84d8720.svg";